// Turn a plain-text post into text, link, and image parts.
// Image marks look like ![alt](url). Everything else stays text, except
// http and https addresses, which become links.

const DATA_IMAGE_BODY = "data:image\\/(?:png|jpe?g|gif|webp);base64,[A-Za-z0-9+/]+={0,2}"
const DATA_IMAGE = new RegExp(`^${DATA_IMAGE_BODY}$`)
const TOKEN = new RegExp(
  `!\\[([^\\]]*)\\]\\((https?:\\/\\/[^\\s)]+|\\/blog_images\\/[A-Za-z0-9][A-Za-z0-9._-]*|${DATA_IMAGE_BODY})\\)|https?:\\/\\/[^\\s<>"']+`,
  "g"
)

export function inlineImageUrl(value) {
  const url = String(value || "").replace(/\s+/g, "")
  return DATA_IMAGE.test(url) ? url : ""
}

function countChar(value, char) {
  let count = 0
  for (let i = 0; i < value.length; i += 1) {
    if (value[i] === char) count += 1
  }
  return count
}

function splitTrailing(raw) {
  let url = raw
  let rest = ""
  while (url.length) {
    const punct = url.match(/[.,;:!?]+$/)
    if (punct) {
      rest = punct[0] + rest
      url = url.slice(0, -punct[0].length)
      continue
    }
    if (url.endsWith(")") && countChar(url, ")") > countChar(url, "(")) {
      rest = ")" + rest
      url = url.slice(0, -1)
      continue
    }
    break
  }
  return { url, rest }
}

function isLinkable(url) {
  return /^https?:\/\/[^\s/?#].+/.test(url)
}

export function parsePostBody(body) {
  const text = body == null ? "" : String(body)
  const parts = []
  let last = 0
  TOKEN.lastIndex = 0
  let match = TOKEN.exec(text)
  while (match) {
    if (match.index > last) {
      parts.push({ type: "text", text: text.slice(last, match.index) })
    }
    if (match[2]) {
      parts.push({ type: "image", alt: match[1], url: match[2] })
    } else {
      const split = splitTrailing(match[0])
      if (isLinkable(split.url)) {
        parts.push({ type: "link", url: split.url, text: split.url })
        if (split.rest) parts.push({ type: "text", text: split.rest })
      } else {
        parts.push({ type: "text", text: match[0] })
      }
    }
    last = match.index + match[0].length
    match = TOKEN.exec(text)
  }
  if (last < text.length) parts.push({ type: "text", text: text.slice(last) })
  return parts
}
